import { render } from "./gamesTab.vue?vue&type=template&id=8051b25a&scoped=true"
import script from "./gamesTab.vue?vue&type=script&lang=js"
export * from "./gamesTab.vue?vue&type=script&lang=js"

import "./gamesTab.vue?vue&type=style&index=0&id=8051b25a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8051b25a"]])

export default __exports__